import lottie from 'lottie-web';

export const hero = () => {
    
  const lottieContainer = document.getElementById('hero__animation-container');

  if (lottieContainer) {

    try {
      const animation = lottie.loadAnimation({
        container: lottieContainer, // The container element
        renderer: 'svg', // Render type: 'svg', 'canvas', or 'html'
        loop: true, // Set to false for one-time play
        autoplay: true, // Start automatically
        path: '/wp-content/themes/warburg-pincus-wealth-solutions/lib/lottie/hero.json', // Path to the animation file
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid meet', // Top right aligned, height fills container, width auto
          clearCanvas: true,
          progressiveLoad: false,
          hideOnTransparent: true
        }
      });

      animation.setSpeed(0.15);

      // Add event listeners for debugging
      animation.addEventListener('complete', () => {
      });

      animation.addEventListener('loopComplete', () => {
      });

      animation.addEventListener('data_ready', () => {
      });

      animation.addEventListener('DOMLoaded', () => {
      });

    } catch (error) {
      console.error('Error loading Lottie animation:', error);
    }

  } else {
    console.warn('Hero animation container not found! Make sure the element with ID "hero__animation" exists.');
  }
}